import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => {
    const {
        textField,
        listItem: { removedColor },
        reports: { editColor },
    } = theme;

    return {
        iconLock: {
            verticalAlign: 'middle',
        },
        listItemEdited: {
            backgroundColor: editColor,
        },
        listItemRemoved: {
            backgroundColor: removedColor,
        },
        lock: {
            width: '30px',
            paddingLeft: '8px',
            paddingRight: '8px',
            flexGrow: 0,
            flexShrink: 0,
            alignSelf: 'center',
        },
        service: {
            flexGrow: 1,
            fontSize: textField.textFontSize,

            ['@media (max-width: 600px)']: {
                width: '100%',
            },
        },
        serviceWrapper: {
            display: 'flex',
            paddingRight: theme.spacing(7),
            flexDirection: 'row',
            justifyContent: 'space-between',

            ['@media (max-width: 600px)']: {
                flexWrap: 'wrap',
                justifyContent: 'flex-start',
            },
        },
        textDisable: {
            opacity: 0.4,
        },
        time: {
            width: '60px',
            paddingLeft: '8px',
            paddingRight: '8px',
            flexGrow: 0,
            flexShrink: 0,
            alignSelf: 'center',

            fontWeight: 600,
        },
    };
});
